(function ($) {
  window.selectOrNative = function(selector) {
    if (!Modernizr.touch) {
      selector.find('select').each(function(){
        new Select({
            el: this,
            alignToHighlighted: 'always'
        });
      });
    }
    else {
      selector.find('select').each(function(){
        $(this).selectTouch();
      });
    }
  }

  // replacement selectboxu, pokud mame touchscreen
  $.fn.selectTouch = function() {
    let text = $(`
      <div class="select-target select-theme-default select-touchdevice">
        <span>${$(this).find('option:selected').text()}</span>
        <i class="sa-icon icon-sipka-dolu2"></i>
      </div>
    `).insertBefore($(this))

    // var text = $('<span/>', {
    //   class: 'select-text',
    //   html: $(this).find('option:selected').text()
    // }).insertBefore($(this));

    $(this).addClass('select-touch');

    $(this).change(function() {
      text.find('span').html($(this).find('option:selected').text());
    });
  };
})(jQuery);
